import { render, staticRenderFns } from "./CheckPlagiarism.vue?vue&type=template&id=1eb968d0&scoped=true"
import script from "./CheckPlagiarism.vue?vue&type=script&lang=js"
export * from "./CheckPlagiarism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb968d0",
  null
  
)

export default component.exports